import { render, staticRenderFns } from "./AdminsView.vue?vue&type=template&id=74013060"
import script from "./AdminsView.vue?vue&type=script&lang=ts"
export * from "./AdminsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports